// extracted by mini-css-extract-plugin
export default {"toast":"toast_toast__NCaof"};